export default __webpack_public_path__ + "static/media/profile-uncheck.b685692d.svg";